<template>
  <SidebarLayout :classname="'section-np project-page' + ($route.params.list ? ' list-page' : '')">
    <ProjectTopMenu v-if="project" :project="project" @refresh-project-info="refreshProjectInfo" />
    <router-view v-if="project" />
  </SidebarLayout>
</template>

<script>
  import { mapActions, mapMutations, mapState } from 'vuex';
  import projectQuery from '@/gql/estimate/project.graphql';
  import ProjectTopMenu from '@/containers/top-menu/index';
  import SidebarLayout from '@/layouts/SidebarLayout';
  import project from '@/store/project';
  import projectTenders from '@/store/project-tenders';
  import { addModule } from '@/store';

  export default {
    name: 'Project',
    components: { SidebarLayout, ProjectTopMenu },
    created() {
      addModule('project', project);
      addModule('projectTenders', projectTenders);
    },
    apollo: {
      project() {
        return {
          fetchPolicy: 'no-cache',
          query: projectQuery,
          variables: {
            id: this.$route.params.id,
            user_id: this.$store.state.auth.user?.id,
          },
          update(data) {
            if (data) {
              // If no project found – redirect to projects page
              if (!data.projects?.length) this.$router.push({ name: 'projects' });

              // If no version (by url) found, redirect to the last created version with apollo reload
              if (data.projects[0]) {
                this.changeCurrentProject(data.projects[0]);
                this.setProjectTitle(data.projects[0].name);
              }
              return data.projects[0] || {};
            }
            return {};
          },
        };
      },
    },
    computed: {
      ...mapState({
        projectUpdate: (state) => state.global.projectUpdate,
        // historyUpdate: (state) => state.history.updated,
      }),
    },
    watch: {
      '$route.params.id': function (id, oldId) {
        // с урла идет строка, в сторе хранится число
        if (+id !== +oldId) {
          this.refreshProjectInfo();
          this.loadTenders({ projectId: id, status: this.$route.params.status });
        }
      },
      projectUpdate: async function (val) {
        if (val && typeof val === 'object') {
          await this.$apollo.queries.project.refetch({
            id: this.$route.params.id,
          });
        } else {
          await this.$apollo.queries.project.refetch();
        }
        await this.$store.dispatch('global/changeProjectUpdate', null);
      },
    },
    methods: {
      ...mapActions('global', ['changeCurrentProject']),
      ...mapActions('projectTenders', ['loadTenders']),
      ...mapActions('sidebarProjects', ['loadSidebarProjectsList']),
      ...mapMutations('projectTenders', ['setProjectTitle']),
      async refreshProjectInfo() {
        const routeParams = this.$route.params;
        await this.$apollo.queries.project.refetch({
          id: routeParams.id,
        });
        await this.loadSidebarProjectsList();
      },
    },
  };
</script>
